import { render, staticRenderFns } from "./IPLicense.vue?vue&type=template&id=6a180a4e&scoped=true&"
import script from "./IPLicense.vue?vue&type=script&lang=js&"
export * from "./IPLicense.vue?vue&type=script&lang=js&"
import style0 from "./IPLicense.vue?vue&type=style&index=0&id=6a180a4e&prod&lang=less&"
import style1 from "./IPLicense.vue?vue&type=style&index=1&id=6a180a4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a180a4e",
  null
  
)

export default component.exports